<template>
  <v-dialog v-model="show_modal" @click:outside="closePopup" scrollable :max-width="maxWidth">
    <v-card>
      <v-toolbar dark flat color="primary" dense>
        <v-toolbar-title>Attendee</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon @click="closePopup">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-card-text>
        <v-row dense class="mt-3">
          <v-col cols="3">
            <v-text-field
              v-model="search_attendee"
              v-debounce:300ms="searchAttendee"
              outlined
              placeholder="Attendee Name"
              hide-details
              dense
              append-icon="mdi-magnify"
            ></v-text-field>
          </v-col>
          <v-col cols="3">
            <v-select
              v-model="search_sponsor_type"
              :items="sponsor_type"
              item-text="name"
              item-value="sponsor_id"
              placeholder="Category"
              outlined
              dense
              @change="searchAttendee"
            ></v-select>
          </v-col>
          <v-col cols="6" class="text-right">
            <v-btn-toggle
              mandatory
            >
              <v-btn @click="is_list_view = true">
                <v-icon>mdi-view-list</v-icon>
              </v-btn>
              <v-btn @click="is_list_view = false">
                <v-icon>mdi-view-grid</v-icon>
              </v-btn>
            </v-btn-toggle>
          </v-col>
        </v-row>

        <v-list v-if="is_list_view">
          <div v-for="(item, index) in attendees_list" :key="index">
            <v-list-item>
              <v-list-item-avatar>
                <v-img :src="item.profile_pic"></v-img>
              </v-list-item-avatar>
              <v-list-item-content>
                <v-list-item-title v-html="item.full_name"></v-list-item-title>
                <v-list-item-subtitle class="mt-1">
                  {{item.company_name}}<span v-if="item.designation"> - {{item.designation}}</span>
                  <span v-if="item.online_status">
                     -
                    <span v-html="item.display_online_status"></span>
                  </span>
                </v-list-item-subtitle>
              </v-list-item-content>
              <v-list-item-action>
                <v-row>
                  <v-btn icon @click="startChatWithAttendee(item)">
                    <v-icon color="grey darken-3"
                      >mdi-message-text-outline</v-icon
                    >
                  </v-btn>
                  <v-btn icon target="_blank" :href="item.linkedin_url" v-if="item.linkedin_url">
                    <v-icon color="light-blue darken-4">mdi-linkedin</v-icon>
                  </v-btn>
                </v-row>
              </v-list-item-action>
            </v-list-item>
            <v-divider v-if="index != attendees_list.length - 1"></v-divider>
          </div>
        </v-list>

        <v-row v-if="!is_list_view">
          <v-col cols="4" v-for="(item, index) in attendees_list" :key="index">
            <v-card
              outlined
            >
              <v-list-item three-line>
                <v-list-item-content>
                  <v-list-item-title class="headline mb-1">
                    {{item.full_name}}
                  </v-list-item-title>
                  <v-list-item-subtitle class="mt-1">
                    {{item.company_name}}
                  </v-list-item-subtitle>
                  <v-list-item-subtitle class="mt-1" v-if="item.designation">
                    {{item.designation}}
                  </v-list-item-subtitle>
                  <v-list-item-subtitle class="mt-1" v-if="item.online_status">
                    <span v-html="item.display_online_status"></span>
                  </v-list-item-subtitle>
                </v-list-item-content>


                <v-list-item-avatar
                  size="80">
                  <v-img :src="item.profile_pic"></v-img>
                </v-list-item-avatar>
              </v-list-item>



              <v-card-actions>
                <v-btn icon @click="startChatWithAttendee(item)">
                  <v-icon color="grey darken-3"
                    >mdi-message-text-outline</v-icon
                  >
                </v-btn>
                <v-btn icon target="_blank" :href="item.linkedin_url" v-if="item.linkedin_url">
                  <v-icon color="light-blue darken-4">mdi-linkedin</v-icon>
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-col>
        </v-row>

        <div v-if="attendees_list.length == 0">
          No Attendee Found!
        </div>

        <div v-if="total_attendees >= 25 && total_attendees > attendee_start_from" class="text-center">
          <v-btn
            elevation="2"
            small
            class="text-capitalize"
            @click="loadMore"
          >Load More</v-btn>
        </div>

      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import {mapState,mapActions,mapMutations} from 'vuex'
import axios from "@/helper/axios"
export default {
  name : 'AttendeePopup',
  data(){
    return {
      is_list_view: true,
      search_attendee: '',
      attendee_start_from: 0,
      sponsor_type: [],
      search_sponsor_type: ''
    }
  },
  watch : {
    show_modal(value){
      if(value){
        this.fetchAttendees()
        this.getSponsorType()
      }
    }
  },
  computed :{
    ...mapState('attendees',['show_modal','attendees_list','total_attendees']),
    ...mapState("utils", ["maxWidth"]),
  },
  methods :{
    ...mapActions('attendees',['fetchAttendees']),
    ...mapMutations("attendees", ["setData"]),
    ...mapMutations("notifications", ["setExpandBox","setTempPrivateMessage","setChatPrivate","setPrivateChatUser"]),
    closePopup(){
      this.setData({
        key : 'show_modal',
        data : false
      })
    },
    getSponsorType() {
      let _self = this;
      axios.get("sponser_type/list?type=ATTENDEE")
      .then(function (response) {
        _self.sponsor_type = response.data.data;
        _self.sponsor_type.unshift({name: "All", sponsor_id: ""});
      })
      .catch(function (e) {
        console.log(e);
      });
    },
    startChatWithAttendee(attendee) {
      this.setChatPrivate(true)
      this.setTempPrivateMessage(attendee)
      this.setPrivateChatUser(attendee)
      this.setExpandBox(0)
      this.closePopup()
    },
    searchAttendee(){
      this.attendee_start_from = 0
      this.setData({
        key : 'search_attendee',
        data : this.search_attendee
      })
      this.setData({
        key : 'attendee_start_from',
        data : this.attendee_start_from
      })
      this.setData({
        key : 'search_sponsor_type',
        data : this.search_sponsor_type
      })
      this.fetchAttendees()
    },
    loadMore(){
      this.attendee_start_from = this.attendee_start_from + 25
      this.setData({
        key : 'attendee_start_from',
        data : this.attendee_start_from
      })
      this.fetchAttendees()
    }
  },
  mounted : function(){
    this.fetchAttendees()
  }
}
</script>